/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/v_magnitude.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculates the magnitude of a dense_vector.
 *
 * @example
 *  from colors
 *  | eval magnitude = v_magnitude(rgb_vector)
 *  | sort magnitude desc, color asc
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'v_magnitude',
  signatures: [
    {
      params: [
        {
          name: 'input',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: true,
  snapshotOnly: true,
};

export default definition;
